import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const VidWrap = styled.div`
  padding-bottom: 56.42857142857143%;
  position: relative;
  height: 0;
  overflow: hidden;

  /* margin: 0;
  width: 100vw;
  margin-left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  max-width: 1000px;
  min-height: 31.2rem; */
`;

const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* border: 0; */
`;

const Video = props => {
  const { id } = props;

  // No video?
  if (!id) {
    return null;
  }

  // Found video
  return (
    <VidWrap className="gatsby-resp-iframe-wrapper">
      <Iframe
        src={`https://www.youtube.com/embed/${id}?rel=0&amp;showinfo=0`}
        className="embedVideoIframe"
        allowFullScreen="allowFullScreen"
        mozallowFullScreen="mozallowFullScreen"
        msallowFullScreen="msallowFullScreen"
        oallowFullScreen="oallowFullScreen"
        webkitallowFullScreen="webkitallowFullScreen"
        frameBorder="0"
      />
    </VidWrap>
  );
};

export default Video;

Video.propTypes = {
  id: PropTypes.string,
};
